export class ImageUtilities {
  async createPreviewImage(inputFile, width, height) {
    const imageType = inputFile.type;
    const maxWidth = width || 500;
    const maxHeight = height || 374;

    // <= this must be asynchronous
    const reader = new window.FileReader();

    // Wait for the data url to be loaded from the file
    const dataURL = await new Promise(resolve => {
      reader.onload = e => resolve(e.target.result);
      reader.readAsDataURL(inputFile);
    });

    // Wait for the image to be loaded
    const img = new window.Image();
    await new Promise(resolve => {
      img.onload = resolve;
      img.src = dataURL;
    });

    // Resize the image with a canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // This is an addition to keep the aspect ratio of the image so it won't get distorted
    // See : https://stackoverflow.com/q/3971841/12594730
    const [imgWidth, imgHeight] = [img.naturalWidth, img.naturalHeight];
    const ratio = Math.min(maxWidth / imgWidth, maxHeight / imgHeight);
    canvas.width = imgWidth * ratio;
    canvas.height = imgHeight * ratio;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL(imageType, 1);
  }
}
const imageUtilities = new ImageUtilities();
export default imageUtilities;